/** Manual pairing cannot grant Browser access; only the account-authorized v2 flow can. */
export function browserToken(_port: number): undefined { return undefined; }
export function subscribeBrowserPairing(_listener: () => void): () => void { return () => {}; }
export function forgetBrowserPairing(_port: number): void {}
export async function pairNativeBrowser(_port: number, _code: string): Promise<void> {
  throw new Error(UPDATE_REQUIRED_MESSAGE);
}

import {createBrowserAutoLink,createBrowserPortalClient,browserPageNonce,UPDATE_REQUIRED_MESSAGE,type LocalBrowserGrant,type BrowserConnectionState} from './browserAutoLink';
import {privateBrowserEnrollment} from '../gaming/private-pilot/enrollment';
import { nativeToolsStore, watchToolsPresence } from './toolsPresence';
const portalOrigin = import.meta.env.VITE_OMP_PORTAL_URL || 'https://perck.co';
/** Sign in separately so the current Studio project and sources stay mounted. */
export const browserSignInUrl = new URL('/auth/login?returnTo=/', portalOrigin).href;
let automatic:ReturnType<typeof createBrowserAutoLink>|null=null;
let portalClient: ReturnType<typeof createBrowserPortalClient> | null = null;
let presenceWatcher: ReturnType<typeof watchToolsPresence> | null = null;
let presenceObservers = 0;
function auto() {
  if (!automatic) {
    const enrolled=privateBrowserEnrollment();
    const page = enrolled?.pageNonce??browserPageNonce();
    const portal = createBrowserPortalClient(portalOrigin, page);
    portalClient = portal;
    automatic = createBrowserAutoLink({ origin: window.location.origin, pageNonce: page, expected:enrolled?.native, portal: portal.request, fetch: (...args) => fetch(...args) });
    window.addEventListener('pagehide', () => {
      presenceWatcher?.dispose();
      presenceWatcher = null;
      nativeToolsStore.getState().setConnected(null);
      automatic?.dispose();
      portal.dispose();
    }, { once: true });
  }
  return automatic;
}
/** Observing Tools shares Browser's portal/page nonce but never acquires a Browser grant. */
export function startNativeToolsPresence(): () => void {
  auto();
  presenceObservers++;
  if (!presenceWatcher) presenceWatcher = watchToolsPresence({
    origin: window.location.origin,
    discover: signal => portalClient!.request('discover', undefined, signal),
    fetch: (...args) => fetch(...args),
    onChange: connected => nativeToolsStore.getState().setConnected(connected),
  });
  let stopped = false;
  return () => {
    if (stopped) return;
    stopped = true;
    if (--presenceObservers === 0) {
      presenceWatcher?.dispose();
      presenceWatcher = null;
      nativeToolsStore.getState().setConnected(null);
    }
  };
}
export function ensureBrowserConnection(signal:AbortSignal):Promise<LocalBrowserGrant>{return auto().ensure(signal);}
export function subscribeBrowserConnection(listener:()=>void):()=>void{return auto().subscribe(listener);}
export function browserConnectionState():BrowserConnectionState{return auto().state();}
export function clearBrowserConnection(reason?:string):void{automatic?.clear(reason);}

/** Actual selected authenticated grant, captured by the mounted source; contains no bearer. */
export function browserConnectionIdentity(grant:LocalBrowserGrant){
 const state=automatic?.state(),identity=automatic?.identity();
 return state?.grant===grant&&identity?.current()?identity:undefined;
}
